/**
 * Sport-scoped skill assessment keys (labels are generic; UI maps to display strings).
 * Tennis preserves legacy forehand/backhand keys for existing JSONB data.
 */

import type { RacquetSportId } from './racquetSports';

export const TENNIS_ASSESSMENT_SKILL_KEYS = [
  'forehand',
  'backhand',
  'serve',
  'volley',
  'footwork',
  'strategy',
  'mental_game',
] as const;

export type TennisAssessmentSkillKey = (typeof TENNIS_ASSESSMENT_SKILL_KEYS)[number];

export const PICKLEBALL_ASSESSMENT_SKILL_KEYS = [
  'serve',
  'return',
  'dink',
  'drive',
  'volley',
  'footwork',
  'strategy',
] as const;

export const PADEL_ASSESSMENT_SKILL_KEYS = [
  'serve',
  'return',
  'volley',
  'lob',
  'bandeja',
  'footwork',
  'tactics',
] as const;

export const BADMINTON_ASSESSMENT_SKILL_KEYS = [
  'clear',
  'drop',
  'smash',
  'net_play',
  'footwork',
  'serve',
  'tactics',
] as const;

export const SQUASH_ASSESSMENT_SKILL_KEYS = [
  'drive',
  'drop',
  'boast',
  'volley',
  'serve',
  'movement',
  'tactics',
] as const;

export const GENERIC_ASSESSMENT_SKILL_KEYS = [
  'technique',
  'consistency',
  'movement',
  'tactics',
  'match_play',
] as const;

export const SPORT_ASSESSMENT_SKILL_KEYS: Record<RacquetSportId, readonly string[]> = {
  tennis: TENNIS_ASSESSMENT_SKILL_KEYS,
  pickleball: PICKLEBALL_ASSESSMENT_SKILL_KEYS,
  padel: PADEL_ASSESSMENT_SKILL_KEYS,
  badminton: BADMINTON_ASSESSMENT_SKILL_KEYS,
  squash: SQUASH_ASSESSMENT_SKILL_KEYS,
  other: GENERIC_ASSESSMENT_SKILL_KEYS,
};

export function getAssessmentSkillKeysForSport(sportId: RacquetSportId): readonly string[] {
  return SPORT_ASSESSMENT_SKILL_KEYS[sportId];
}

export function isValidAssessmentSkillKey(sportId: RacquetSportId, key: string): boolean {
  return (SPORT_ASSESSMENT_SKILL_KEYS[sportId] as readonly string[]).includes(key);
}
